export default {
  state: {
    wishlist: []
  },
  mutations: {
    setWishlist(state, payload) {
      state.wishlist = payload;
    },
    setWishlists(state, payload) {
      state.wishlist = payload;
    },
    addWishlist(state, payload) {
      state.wishlist.push(payload);
    }
  },
  actions: {
    // deprecated
    setWishlist({ commit }, payload) {
      commit("setWishlist", payload);
    },
    //

    setWishlists({ commit }, payload) {
      commit("setWishlists", payload);
    },
    addWishlist({ commit }, payload) {
      commit("addWishlist", payload);
    }
  },
  getters: {
    wishlist(state) {
      return state.wishlist;
    }
  }
};
